"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgHistory = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M12.029 2C6.522 2 2.057 6.488 2.057 12.025c0 2.356.808 4.522 2.161 6.233l-1.207-.018a.999.999 0 0 0-1.01.986.999.999 0 0 0 .982 1.014l3.988.058a.998.998 0 0 0 1.011-.986l.058-4a.998.998 0 1 0-1.994-.029l-.03 2.013a8.014 8.014 0 0 1-1.965-5.271c0-4.43 3.572-8.02 7.978-8.02 4.405 0 7.977 3.59 7.977 8.02 0 4.09-3.045 7.464-6.98 7.958V20a.999.999 0 0 0-.998 1 .999.999 0 0 0 1.217.976C18.18 21.372 22 17.147 22 12.025 22 6.488 17.536 2 12.029 2Z", fill: color }),
        React.createElement("path", { d: "M16.017 14c.55 0 .997-.448.997-1s-.446-1-.997-1h-2.991V7.5c0-.552-.447-1-.997-1a.999.999 0 0 0-.998 1V13c0 .552.447 1 .998 1h3.988Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgHistory);
//# sourceMappingURL=SvgHistory.js.map